// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/swatches/swatches.less
// module id = 3681
// module chunks = 0